import { Col, Row } from "antd";
import DocListPage from "../../components/DocComponents/DocListPage";

export default function AllDocsPage(){
    return (
        <Row style={{height: '100%'}}>
            <Col span={24}>
                <DocListPage title='ყველა დოკუმენტი' />
            </Col>
        </Row>
    )
}